function parseActivityDate(value) {
    if (!value) {
        return 0;
    }
    if (value instanceof Date) {
        return value.getTime();
    }
    if (typeof value === 'number') {
        return value;
    }
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? 0 : parsed;
}

export function normalizeWalletTransactions(transactions) {
    if (!transactions || !transactions.length) {
        return [];
    }

    return transactions
        .filter((transaction) => {
            return transaction.type === 'course_purchase' || transaction.type === 'lecture_purchase';
        })
        .map((transaction) => {
            const isCourse = transaction.type === 'course_purchase';
            const resource = isCourse ? transaction.course_resource : transaction.lecture_resource;
            const resourceId = resource && resource.id;

            return {
                id: `wallet-${transaction.serial || transaction.type}-${resourceId}`,
                type: transaction.type,
                at: transaction.timestamp,
                title: isCourse ? 'شراء دورة' : 'شراء محاضرة',
                label: resource && resource.name ? resource.name : '',
                icon: isCourse ? 'mdi-play-box-multiple-outline' : 'mdi-clipboard-play-outline',
                route: resourceId
                    ? {
                        name: isCourse ? 'course' : 'lecture',
                        params: { id: resourceId },
                    }
                    : { name: 'wallet' },
            };
        });
}

export function normalizeExamSessions(sessions, kind) {
    if (!sessions || !sessions.length) {
        return [];
    }

    const isHomework = kind === 'homework';
    const routeName = isHomework ? 'my-homeworks' : 'my-exams';
    const titlePrefix = isHomework ? 'واجب' : 'امتحان';
    const icon = isHomework ? 'mdi-notebook-outline' : 'mdi-clipboard-text-outline';

    return sessions
        .filter((session) => session.exam)
        .map((session) => {
            const exam = session.exam;
            const chips = [];

            if (exam && !exam.show_result) {
                chips.push({ text: 'لم تظهر النتيجة', color: 'muted', outlined: true });
            } else if (session.corrected) {
                chips.push({
                    text: session.succeeded ? 'ناجح' : 'راسب',
                    color: session.succeeded ? 'success' : 'error',
                });
            } else {
                chips.push({ text: 'لم يتم التصحيح', color: 'muted', outlined: true });
            }

            if (session.total_mark && session.corrected && exam && exam.show_result) {
                chips.push({
                    text: `${session.correction_mark} / ${session.total_mark}`,
                    color: session.succeeded ? 'success' : 'error',
                    outlined: true,
                    ltr: true,
                });
            }

            return {
                id: `${kind}-${session.id}`,
                type: isHomework ? 'homework' : 'exam',
                at: session.start_time,
                title: titlePrefix,
                label: exam.name,
                icon,
                route: { name: routeName },
                chips,
            };
        });
}

export function normalizeBankQuestions(questions) {
    if (!questions || !questions.length) {
        return [];
    }

    return questions.map((question) => {
        const chips = [{
            text: question.answered ? 'تم الإجابة' : 'في انتظار الإجابة',
            color: question.answered ? 'primary' : 'grey',
            dark: !question.answered,
        }];

        let label = '';
        if (question.text) {
            label = question.text.length > 80 ? `${question.text.slice(0, 80)}…` : question.text;
        } else if (question.image_url) {
            label = 'صورة';
        }

        return {
            id: `question-${question.id}`,
            type: 'bank_question',
            at: question.created_at || question.updated_at,
            title: `سؤال #${question.id}`,
            label,
            icon: 'mdi-file-question-outline',
            route: { name: 'my-questions' },
            chips,
        };
    });
}

export function mergeActivities(items, { limit = 12 } = {}) {
    const flat = items.flat().filter(Boolean);

    return flat
        .sort((a, b) => {
            const dateA = parseActivityDate(a.at);
            const dateB = parseActivityDate(b.at);
            if (dateA !== dateB) {
                return dateB - dateA;
            }
            return String(b.id).localeCompare(String(a.id));
        })
        .slice(0, limit);
}
